import React from "react";
import { AlertCircleIcon, ConnectedAddNewIcon } from "../common/Icon";
import InstagramIcon from "../../assets/images/svg/instagram_icon.svg";
import MessengerIcon from "../../assets/images/svg/messenger_icon.svg";
import statusLevel from "../../assets/images/png/profile_status_level_img.png";
import { Tooltip } from "@material-tailwind/react";

const WorkflowProfileConnected = () => {
  return (
    <>
      <div className="w-[320px] xs:w-[350px] md:w-auto overflow-x-auto overflow_x_scroll_style">
        <div className="px-6 pt-[30px] pb-[38px] w-[700px] md:w-auto ">
          <div className="flex items-center gap-[6px]">
            <h5 className="text-[14px] font-semibold text-black">
              Connect platforms
            </h5>
              <Tooltip content="lorem ipsum"  >
                 <span>
              <AlertCircleIcon />
            </span>
              </Tooltip>
          </div>
          <div className="flex  gap-4 pt-[22px]">
            <div className="w-1/3 mx-auto">
              <button className="text-[14px] font-medium text-primary rounded-[36px] border border-solid border-primary py-2 px-9 xs:px-7 md:px-9 flex items-center gap-[10px] w-full hover:bg-primary hover:text-white duration-200">
                <span>
                  <img
                    className="w-full h-5"
                    src={MessengerIcon}
                    alt="Messenger-icon"
                  />
                </span>
                Messenger
              </button>
            </div>
            <div className="w-1/3 mx-auto">
              <button className="text-[14px] font-medium text-primary rounded-[36px] border border-solid border-primary py-2 px-9 xs:px-7 md:px-9 flex items-center gap-[10px] w-full hover:bg-primary hover:text-white duration-200">
                <span>
                  <img
                    className="w-full h-5"
                    src={InstagramIcon}
                    alt="Instagram-icon"
                  />
                </span>
                Instagram
              </button>
            </div>
            <div className="w-1/3 mx-auto">
              <button className="text-[14px] font-medium text-primary rounded-[36px] border border-solid border-primary py-2 px-9 xs:px-7 md:px-9 flex items-center gap-[10px] w-full hover:bg-primary hover:text-white duration-200">
                <span>
                  <ConnectedAddNewIcon />
                </span>
                Add New
              </button>
            </div>
          </div>
          <div className="flex  items-center gap-[22px]">
            <div className="pt-9 w-full md:w-1/2">
              <div className="flex items-center gap-[6px]">
                <h5 className="text-[14px] font-semibold text-black">
                  Contact Since
                </h5>
                <Tooltip content="lorem ipsum">
                  <span>
                    <AlertCircleIcon />
                  </span>
                </Tooltip>
              </div>
              <input
                className="text-[10px] 2xl:text-[12px] 3xl:text-[14px] font-normal text-black py-[14px] pl-[10px] pr-2.5 placeholder:pr-10 placeholder:text-gray outline-primary rounded-lg border border-solid border-[rgba(0,_0,_0,_0.05)] w-full mt-4 bg-[#FBFBFF]"
                type="text"
                placeholder="How long the user has had them in your database"
              />
            </div>
            <div className="pt-9 w-full md:w-1/2">
              <div className="flex items-center gap-[6px]">
                <h5 className="text-[14px] font-semibold text-black">
                  Time since last update 
                </h5>
                <Tooltip content="lorem ipsum">
                  <span>
                    <AlertCircleIcon />
                  </span>
                </Tooltip>
              </div>
              <input
                className="text-[10px] 2xl:text-[12px] 3xl:text-[14px] font-normal text-black py-[14px] pl-[10px] pr-2.5 placeholder:pr-10 placeholder:text-gray outline-primary rounded-lg border border-solid border-[rgba(0,_0,_0,_0.05)] w-full mt-4  bg-[#FBFBFF]"
                type="text"
                placeholder="25 / May / 2023"
              />
            </div>
          </div>
          <div className=" pt-5 lg:pt-9">
            <div className="flex items-center gap-[6px]">
              <h5 className="text-[14px] font-semibold text-black">
                Set Status Level
              </h5>
              <Tooltip content="lorem ipsum">
                <span>
                  <AlertCircleIcon />
                </span>
              </Tooltip>
            </div>
            <div className="pt-6 flex  items-center gap-[80px]">
              <img
                className=" w-full max-w-[304px]"
                src={statusLevel}
                alt="statusLevel-img"
              />
              <div>
                <div className="flex items-center gap-3 ">
                  <span className="bg-red_gradient w-[22px] h-[22px]"></span>
                  <p className="text-[14px] font-semibold text-black opacity-70">
                    Low Interest
                  </p>
                </div>
                <div className="flex items-center gap-3 pt-3.5 ">
                  <span className="bg-new_bule w-[22px] h-[22px]"></span>
                  <p className="text-[14px] font-semibold text-black opacity-70">
                    Medium Interest
                  </p>
                </div>
                <div className="flex items-center gap-3 pt-3.5 ">
                  <span className="bg-yesllo_gradient w-[22px] h-[22px]"></span>
                  <p className="text-[14px] font-semibold text-black opacity-70">
                    High Interest
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-[6px] pt-8 pb-3">
            <h5 className="text-[14px] font-semibold text-black">Hashtags</h5>
            <Tooltip content="lorem ipsum">
              <span>
                <AlertCircleIcon />
              </span>
            </Tooltip>
          </div>
          <textarea
            className="text-xs 3xl:text-[16px] w-full font-normal text-black bg-light_purple7 placeholder:opacity-[0.21] py-2 px-2 rounded-lg border border-solid border-[rgba(0,_0,_0,_0.05)] outline-primary resize-none"
            cols="90"
            rows="5"></textarea>
        </div>
      </div>
    </>
  );
};

export default WorkflowProfileConnected;
